module.exports = __webpack_public_path__ + "static/media/CNBC_Economist_Logo_White.a780f3f3.png";